/**
 * src/pages/Support.jsx
 *
 * created by pycui on 8/18/23
 */

import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography, Grid, CircularProgress } from "@mui/material";
import LoadingData from "../education/dataloading";
import { CardActions, Button } from "@mui/material";
import { useTranslation } from 'react-i18next';

import { useSnackbar } from "../SnackbarProvider";
import { requestUrl } from "../requestUrl";
const Support = () => {

  const [softwareList, setSoftwareList] = useState([]);
  const [loading, setLoading] = useState(true);
  const showSnackbar = useSnackbar();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText,setLoadingText] = useState('loading');

  useEffect(() => {
   
    
    const fetchData = async () => {
        try {
            //setIsLoading(true);
            //setLoadingText("loading");
            const dataToSend = {
                id:0,
            };
            const data = await requestUrl(dataToSend, "get_software",t,showSnackbar);
            if(data.status === "success"){
              console.log(data.data);
              setSoftwareList(data.data);
              
            }
            
            
          } catch (error) {
              console.error("获取数据时出错:", error);
              //setIsLoading(false);
          } finally {
            //setIsLoading(false);
          }
    };

    fetchData();
  

  
}, []);


 


  return (
    <div className='home'>
      <h1>Get Support for Zhigu</h1>

      <p>
        We&apos;re here to help! If you encounter any issues or have questions,
        here&apos;s how you can get support:
      </p>

      <ul>
        <li>
          <strong>Contact Support:</strong> If you need direct assistance, you
          can always reach out to us at{' '}
          <a href='service@chentu.co'>service@chentu.co</a>.
          宋老师email:skys1982@hotmail.com
        </li>
      </ul>


      <Grid container spacing={2} padding={2}>
  {softwareList.map((software) => (
    <Grid item xs={12} md={6} lg={4} key={software.id}>
      <Card sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {software.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            大小: {software.size}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {software.des}
          </Typography>
        </CardContent>
        <CardActions sx={{ marginTop: "auto" }}>
          <Button 
            variant="contained" 
            color="primary" 
            fullWidth 
            href={software.url}
            target="_blank"
          >
            下载
          </Button>
        </CardActions>
      </Card>
    </Grid>
  ))}
</Grid>


    </div>
  );
};

export default Support;
